<template>
  <!-- Visually hidden until focused (first Tab on the page), then a real skip link to the main content.

       `focus:z-[200]` is left alone on purpose. §3.8's ladder has eight rungs and none of them names
       a skip link, and the nearest honest one — `toast` (100) — is BELOW `BaseModal`'s live 140 and
       ties with `AppHeader`'s staged `z-100`. Converting this one token in isolation would move the
       first thing a keyboard user touches underneath the header. The eleven overlays are one atomic
       decision; see the note in `ToastBar.vue`. -->
  <a
    href="#main-content"
    class="sr-only rounded-lg bg-brand-action px-4 py-2 text-sm font-medium text-white focus:not-sr-only focus:absolute focus:start-3 focus:top-3 focus:z-[200]"
  >
    پرش به محتوای اصلی
  </a>
</template>
